import { render, staticRenderFns } from "./DomainDetectionSummary.vue?vue&type=template&id=58cc4f38&scoped=true"
import script from "./DomainDetectionSummary.vue?vue&type=script&lang=js"
export * from "./DomainDetectionSummary.vue?vue&type=script&lang=js"
import style0 from "./DomainDetectionSummary.vue?vue&type=style&index=0&id=58cc4f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc4f38",
  null
  
)

export default component.exports